
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA à Issy-les-Moulineaux dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Issy-les-Moulineaux certifiée Google Partner, aide les entreprises isséennes à développer leur visibilité en ligne et à générer plus de prospects.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads à Issy-les-Moulineaux dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Issy-les-Moulineaux certifiée Google Partner, aide les entreprises isséennes à développer leur visibilité en ligne et à générer plus de prospects.",
        },
      ],
    };
  },
};
